// extracted by mini-css-extract-plugin
module.exports = {"className":"textInspirationalTitleL_className__ekw9P"};